<template>
  <div id="vue" :class="['result-zk-suc-page', { 'tg-frame': isTGFrame }]" v-cloak ref="container">
    <div class="result-zk-top-bg" aria-hidden="true" />

    <div class="result-zk-card result-zk-card--first">
      <div class="result-zk-card-title salutation-line">
        {{ displayRealName ? displayRealName + '！' : '' }}您的初审预估额度为(元):
      </div>
      <div class="result-zk-amount">{{ amountDisplay }}</div>
    </div>

    <div class="result-zk-card">
      <div class="result-zk-provider-cap">
        <span class="cap-line" />
        <span class="result-zk-provider-cap-center">
          本次贷款服务提供方
          <i
            class="info-ico info-ico--cap"
            role="button"
            aria-label="服务说明"
            @click.stop="showProviderServiceTip"
            >i</i
          >
        </span>
        <span class="cap-line right" />
      </div>
      <div class="result-zk-provider-info">
        <p class="result-zk-provider-info-row">
          产品名称：{{ pagedata.mainPushProductName || '—' }}
        </p>
        <p class="result-zk-provider-info-row">
          公司名称：{{ pagedata.mainPushMerchantName || '—' }}
        </p>
        <!-- 撞库结果同样只展示接口返回的年化利率，未返回时不渲染该行。 -->
        <p v-if="pagedata.annualRate" class="result-zk-provider-info-row">
          年化利率(单利)：{{ pagedata.annualRate }}(已包含全部息费)
        </p>
        <p v-if="pagedata.phone" class="result-zk-provider-info-row">
          公司电话：{{ pagedata.phone }}
        </p>
      </div>
      <div class="result-zk-stats">
        <div class="result-zk-stat">
          <div class="result-zk-stat-val">{{ goodReviewRate }}</div>
          <div class="result-zk-stat-label">好评率</div>
        </div>
        <div class="result-zk-stat">
          <div class="result-zk-stat-val">{{ serviceUserCount }}</div>
          <div class="result-zk-stat-label">服务人数</div>
        </div>
        <div class="result-zk-stat">
          <div class="result-zk-stat-val">{{ loanSuccessRate }}</div>
          <div class="result-zk-stat-label">下款成功率</div>
        </div>
      </div>
    </div>

    <!-- 多产品：想提升放款率（默认收起，展开/收起带动画）；半流程多推不展示多选 -->
    <!-- <div class="result-zk-recommend" v-if="pagedata.items.length > 0 && !isHalfMorePush">
      <div class="result-zk-recommend-head" @click="recommendExpanded = !recommendExpanded">
        <div class="result-zk-recommend-head-text">
          <div class="result-zk-recommend-title">想提升放款率？</div>
          <p class="result-zk-recommend-plans">
            <span class="result-zk-recommend-plans-prefix">为您推荐以下平台方案</span>
            <span class="result-zk-recommend-plans-names">{{ recommendProductNames }}</span>
          </p>
        </div>
        <van-icon
          name="arrow-down"
          class="result-zk-recommend-arrow"
          :class="{ 'result-zk-recommend-arrow--open': recommendExpanded }"
        />
      </div>
      <transition name="result-zk-recommend-expand">
        <div v-show="recommendExpanded" class="result-zk-recommend-body">
          <div class="result-zk-recommend-list">
            <div
              v-for="(row, idx) in pagedata.items"
              :key="'pick-' + idx"
              class="result-zk-recommend-row"
            >
              <div class="result-zk-recommend-text">
                <div class="result-zk-recommend-product">{{ row.productName }}</div>
                <div class="result-zk-recommend-company">{{ row.lastMerchantName }}</div>
              </div>
              <van-checkbox
                :value="isPickRowChecked(row)"
                shape="square"
                icon-size="18px"
                class="result-zk-recommend-check"
                :bind-group="false"
                @input="onPickRowCheck(row, $event)"
              />
            </div>
          </div>
        </div>
      </transition>
    </div> -->

    <div v-if="showAgreeBlock" class="result-zk-agree-block">
      <div class="result-zk-special">
        特别提示：为您匹配专业的贷款咨询机构，请您查阅
        <template v-if="isUnionLogin">
          <span class="link" @click.stop="openProtocolByKey('union')">《联登授权协议》</span>
          <template v-if="showAgencyTab">
            和
            <span class="link" @click.stop="openOrgProtocolsSheet">《机构相关协议》</span>
          </template>
        </template>
        <template v-else>
          <span class="link" @click.stop="openProtocolByKey('share')">《个人信息共享授权书》</span>
          <span class="link" @click.stop="openProtocolByKey('notice')">《知情告知书》</span>
          <template v-if="showAgencyTab">
            和
            <span class="link" @click.stop="openOrgProtocolsSheet">《机构相关协议》</span>
          </template>
        </template>
      </div>

      <div class="result-zk-tabs">
        <div
          class="result-zk-tab"
          :class="{ active: agreementTab === 'platform' }"
          @click="agreementTab = 'platform'"
        >
          {{ isUnionLogin ? '联登授权协议' : '平台相关协议' }}
        </div>
        <div
          v-if="showAgencyTab"
          class="result-zk-tab"
          :class="{ active: agreementTab === 'agency' }"
          @click="agreementTab = 'agency'"
        >
          机构相关协议
        </div>
      </div>

      <div class="result-zk-protocol-box">
        <div v-show="agreementTab === 'platform'">
          <div v-html="platformProtocolHtml" />
        </div>
        <div v-show="showAgencyTab && agreementTab === 'agency'">
          <div
            v-for="(item, idx) in orgAgreementList"
            :key="'orgpv-' + orgAgreementSig + '-' + idx"
            class="protocol-iframe-wrap"
          >
            <div class="protocol-inner-title">{{ item.contractName }}</div>
            <iframe
              v-if="contractIframeSrc(item)"
              :src="contractIframeSrc(item)"
              title="protocol-org"
              loading="lazy"
            />
            <div v-else class="protocol-org-html" v-html="orgAgreementHtml(item)" />
          </div>
        </div>
      </div>
    </div>

    <div class="result-zk-footer">
      <van-button
        block
        round
        native-type="button"
        class="result-zk-apply-btn"
        :disabled="loading"
        :loading="loading"
        @click="handleApply"
      >
        {{ applyButtonText }}
      </van-button>
    </div>

    <van-action-sheet
      v-model="protocolShow"
      class="protocol-sheet protocol-sheet-zk"
      round
      :lazy-render="false"
      close-on-popstate
      @close="handleCloseProtocol"
    >
      <div slot="default" class="protocol-sheet-body">
        <header class="protocol-sheet-header">
          <div v-if="protocolTitle" class="protocol-sheet-header-title">
            {{ protocolTitle }}
          </div>
          <van-icon
            name="cross"
            class="protocol-sheet-header-close"
            @click="protocolShow = false"
          />
        </header>
        <div class="protocol-sheet-scroll">
          <div
            v-if="orgSheetIframesMounted"
            v-show="protocolPopupMode === 'org'"
            class="protocol-sheet-org"
          >
            <div
              v-for="(item, idx) in orgAgreementList"
              :key="'porg-' + orgAgreementSig + '-' + idx"
              class="protocol-sheet-org-frame"
            >
              <div v-if="item.contractName" class="protocol-inner-title">
                {{ item.contractName }}
              </div>
              <iframe
                v-if="contractIframeSrc(item)"
                :src="contractIframeSrc(item)"
                title="sheet-org"
                loading="lazy"
              />
              <div v-else class="protocol-org-html" v-html="orgAgreementHtml(item)" />
            </div>
          </div>
          <div
            v-show="protocolPopupMode !== 'org'"
            class="protocol-sheet-html"
            v-html="protocolContent"
          />
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
import { replaceTemplateValues } from '@/utils/replaceTemplateValues.js'
import { entryCommon } from '@/mixins/entryCommon.js'
import { isInTGFrame } from '@/utils/tgFrame'
import { setCookie } from '@/utils/cookies.js'

export default {
  name: 'ResultZkSucComn',
  mixins: [entryCommon],

  data() {
    const q = this.$route.query || {}
    const qs = (key) => (q[key] == null || q[key] === undefined ? '' : String(q[key]))
    return {
      jwt: qs('jwt'),
      source: qs('source'),
      productId: qs('productId'),
      applyId: qs('applyId'),
      apiReqType: qs('apiReqType'),
      redirectUrl: qs('redirectUrl'),
      hasPushSuccess: qs('hasPushSuccess'),
      isMorePush: qs('isMorePush') || qs('IsMorePush'),

      isH5DownloadAppShow: qs('isH5DownloadAppShow'),
      isRedirectProductsPage: qs('isRedirectProductsPage'),
      downPageUrlTid: qs('downPageUrlTid'),
      applyPageUrlTid: qs('applyPageUrlTid'),
      loanSuperPageRedirectRule: qs('loanSuperPageRedirectRule'),
      downPageUrl: qs('downPageUrl'),

      pagedata: {
        goodReviewRate: '', // 好评率
        serviceUserCount: '', // 服务人数
        loanSuccessRate: '', // 下款成功率
        annualRate: '', // 结果接口返回的年化利率
        items: [], // 产品列表
        productIds: [], // 选中的产品ID列表
      },

      realName: qs('realName'), // 姓名
      idCard: qs('idCard'), // 身份证号
      loanAmount: qs('loanAmount'), // 贷款金额

      defaultAgreements: [], // 平台协议
      thirdAgreements: [], // 顶层机构协议（agreements.thirdAgreement）
      productContractDTOS: [], // 联登产品协议
      checkMobileStatus: null, // 0=H5 隐藏协议区；2=联登；其它保持原逻辑
      agreementTab: 'platform', // 协议标签
      protocolShow: false,
      protocolPopupMode: '', // 协议弹窗模式
      protocolTitle: '', // 协议标题
      protocolContent: '', // 协议内容
      titles: {
        13: '个人信息共享授权书',
        14: '知情告知书',
        org: '机构相关协议',
        union: '联登授权协议',
      },
      loading: false, // 加载状态
      orgSheetIframesMounted: false, // 弹窗内机构协议 iframe 懒加载
      recommendExpanded: false, // 推荐展开状态
      processId: qs('processId'),
      h5ChannelCode: qs('h5ChannelCode'),
    }
  },
  computed: {
    isTGFrame() {
      return isInTGFrame()
    },
    /** 0=H5 产品：隐藏协议红框 */
    isH5Product() {
      return this.checkMobileStatus === 0 || this.checkMobileStatus === '0'
    },
    /** 2=联登产品：特别提示改为联登授权协议 + 机构相关协议 */
    isUnionLogin() {
      return this.checkMobileStatus === 2 || this.checkMobileStatus === '2'
    },
    showAgreeBlock() {
      return !this.isH5Product
    },
    displayRealName() {
      return this.realName || (this.pagedata && this.pagedata.realName) || ''
    },
    /** 地址栏 isMorePush=1 表示半流程多推 */
    isHalfMorePush() {
      return String(this.isMorePush) === '1'
    },
    orgAgreementList() {
      return [...this.thirdOrgAgreementList, ...this.itemOrgAgreementList]
    },
    /** 顶层 agreements.thirdAgreement 机构协议 */
    thirdOrgAgreementList() {
      const out = []
      const pushFromGroup = (g) => {
        if (!g) return
        ;(g.agreements || []).forEach((a) => {
          if (!a) return
          if (!this.orgAgreementHasDisplayableContent(a)) return
          out.push({ ...a, _thirdCompanyName: g.companyName || g.productName || '' })
        })
      }
      ;(this.thirdAgreements || []).forEach(pushFromGroup)
      return out
    },
    /** 多选 items 勾选行对应的机构协议；半流程多推不展示 */
    itemOrgAgreementList() {
      if (this.isHalfMorePush) return []
      const out = []
      const pushFromGroup = (g) => {
        if (!g) return
        ;(g.agreements || []).forEach((a) => {
          if (!a) return
          if (!this.orgAgreementHasDisplayableContent(a)) return
          out.push({ ...a, _thirdCompanyName: g.companyName || g.productName || '' })
        })
      }
      ;(this.pagedata.items || []).forEach((row) => {
        if (!this.isPickRowChecked(row)) return
        this.resolveItemAgreementsThirdGroups(row).forEach(pushFromGroup)
      })
      return out
    },
    orgAgreementSig() {
      return this.orgAgreementList
        .map((x) =>
          [
            x.contractName,
            x._thirdCompanyName,
            this.contractIframeSrc(x),
            String(x.contractContent || '').slice(0, 48),
          ].join('::')
        )
        .join('|')
    },
    showAgencyTab() {
      return this.orgAgreementList.length > 0
    },
    platformProtocolHtml() {
      if (this.isUnionLogin) {
        const item = this.findUnionAgreement()
        const raw = item ? this.wrapPlatformBlock(item) : ''
        const html = this.applyProtocolTemplateReplace(raw)
        return html || '<p>协议内容加载中或暂未配置。</p>'
      }
      const joined = (this.defaultAgreements || [])
        .map((item) => this.wrapPlatformBlock(item))
        .filter(Boolean)
        .join('<div style="height:0.32rem"></div>')
      const html = this.applyProtocolTemplateReplace(joined)
      return html || '<p>协议内容加载中或暂未配置。</p>'
    },
    // 金额显示
    amountDisplay() {
      const n = this.loanAmount || (this.pagedata && this.pagedata.loanAmount)
      const num = Number(n)
      if (Number.isNaN(num)) return '200,000'
      return num.toLocaleString('en-US')
    },
    goodReviewRate() {
      return this.formatStatPercent(this.pagedata.goodReviewRate)
    },
    serviceUserCount() {
      return this.formatStatCount(this.pagedata.serviceUserCount)
    },
    loanSuccessRate() {
      return this.formatStatPercent(this.pagedata.loanSuccessRate)
    },
    applyButtonText() {
      if (this.loading) {
        return '提交中...'
      }
      return '同意协议 立即申请'
    },
    recommendProductNames() {
      return (this.pagedata.items || [])
        .map((r) => r.productName)
        .filter(Boolean)
        .join('、')
    },
  },
  watch: {
    showAgencyTab(v) {
      if (!v && this.agreementTab === 'agency') {
        this.agreementTab = 'platform'
      }
    },
    agreementTab(v) {
      if (v === 'agency' && !this.showAgencyTab) {
        this.agreementTab = 'platform'
      }
    },
  },
  async mounted() {
    await this.handleJwtLogin()
    API_Common.handleBatchTrackBase(100065)
    this.pageInit()
  },
  methods: {
    async handleJwtLogin() {
      if (!this.jwt) return
      // 沿用表单页登录态结构，并在接口启动前完成 Cookie 与 Vuex 的双重同步。
      setCookie('token', this.jwt)
      await this.$store.dispatch('setJwt', this.jwt)
    },
    async pageInit() {
      this.reportPageViewIfNeeded()
      await this.initMockData()
      if (this.isHalfMorePush && this.productId) {
        API_Common.scheduleDelayPushApply({
          applyId: this.applyId || '',
          productId: this.productId,
          channelCode: this.source || '',
        }).catch(() => {})
      }
    },
    /** 半流程多推（isMorePush=1）进入页面上报 pageView */
    reportPageViewIfNeeded() {
      if (!this.isHalfMorePush) return
      const processId = this.$route.query.processId
      if (!processId) return
      API_Common.pageView(processId, this.source)
    },
    /** 将接口返回的 data（含 agreements）写入页面：平台协议 + 机构协议数据源 */
    applyCollisionPayload(src) {
      if (!src || typeof src !== 'object') return
      const keys = [
        'merchantName',
        'goodReviewRate',
        'serviceUserCount',
        'loanSuccessRate',
        'annualRate',
        'realName',
        'idCard',
        'loanAmount',
        'phone',
        'mainPushProductName',
        'mainPushMerchantName',
      ]
      keys.forEach((k) => {
        if (src[k] !== undefined) this.$set(this.pagedata, k, src[k])
      })
      if (src.items) this.$set(this.pagedata, 'items', src.items)
      if (src.productIds != null) this.$set(this.pagedata, 'productIds', [...src.productIds])
      if (src.checkMobileStatus !== undefined && src.checkMobileStatus !== null) {
        this.checkMobileStatus = src.checkMobileStatus
      }
      if (Array.isArray(src.productContractDTOS)) {
        this.productContractDTOS = src.productContractDTOS
      }

      const ag = src.agreements || {}
      this.defaultAgreements = Array.isArray(ag.defaultAgreements) ? ag.defaultAgreements : []
      this.thirdAgreements = this.normalizeThirdAgreementToGroups(ag.thirdAgreement)
      this.fillMissingApplyFields(src)
    },
    /** 登录只带 source 进页时，用 secondPushProduct 回填进件入参；apiReqType 缺省按闪借花 1 */
    fillMissingApplyFields(src) {
      if (!src || typeof src !== 'object') return
      const first = (src.items && src.items[0]) || {}
      const pick = (...vals) => {
        for (let i = 0; i < vals.length; i++) {
          const v = vals[i]
          if (v != null && v !== '') return String(v)
        }
        return ''
      }
      if (!this.productId) {
        this.productId = pick(
          src.productId,
          src.mainPushProductId,
          first.productId,
          Array.isArray(src.productIds) ? src.productIds[0] : ''
        )
      }
      if (!this.applyId) this.applyId = pick(src.applyId)
      if (!this.apiReqType) this.apiReqType = pick(src.apiReqType, '1')
      if (!this.redirectUrl) this.redirectUrl = pick(src.redirectUrl)
      if (!this.downPageUrl) this.downPageUrl = pick(src.downPageUrl)
      if (!this.isRedirectProductsPage) {
        this.isRedirectProductsPage = pick(src.isRedirectProductsPage)
      }
      if (!this.loanSuperPageRedirectRule) {
        this.loanSuperPageRedirectRule = pick(src.loanSuperPageRedirectRule)
      }
    },
    // 包装平台协议块
    wrapPlatformBlock(item) {
      if (!item) return ''
      const title = item.contractName || ''
      const body = item.contractContent || ''
      if (!body && item.contractUrl) {
        const u = String(item.contractUrl).trim()
        return (
          (title ? `<div class="protocol-inner-title">${title}</div>` : '') +
          `<iframe src="${u}" />`
        )
      }
      const hasTitleInBody =
        body.includes('protocol-inner-title') || (title && body.includes(title))
      const titleHtml =
        !hasTitleInBody && title ? `<div class="protocol-inner-title">${title}</div>` : ''
      return titleHtml + body
    },
    // 查找平台协议
    findPlatformAgreement(key) {
      const list = this.defaultAgreements || []
      if (key === 'share') {
        return (
          list.find((a) => /个人信息共享|个人信息使用|共享授权/.test(a.contractName || '')) ||
          list[0]
        )
      }
      if (key === 'notice') {
        return list.find((a) => /知情告知/.test(a.contractName || '')) || list[1]
      }
      return null
    },
    /** 联登产品对应的联登协议：优先 productContractDTOS，其次名称含「联登」的平台协议 */
    findUnionAgreement() {
      const contracts = this.productContractDTOS || []
      const fromDto = contracts.find(
        (a) => a && (this.contractIframeSrc(a) || String(a.contractContent || '').trim())
      )
      if (fromDto) return fromDto
      const list = this.defaultAgreements || []
      return list.find((a) => /联登/.test(a.contractName || '')) || list[0] || null
    },
    /**
     * 推荐行 items[].agreements：
     * - 对象且含 thirdAgreement：走 normalizeThirdAgreementToGroups；
     * - 字符串：JSON 解析为 [{ contractName, contractUrl }...]；
     * - 已是数组：同上，作为该行机构协议列表（带 companyName / productName 展示用前缀）。
     */
    resolveItemAgreementsThirdGroups(row) {
      if (!row || row.agreements == null) return []

      const ag = row.agreements

      if (typeof ag === 'object' && !Array.isArray(ag) && ag.thirdAgreement != null) {
        return this.normalizeThirdAgreementToGroups(ag.thirdAgreement)
      }

      let raw = ag
      if (typeof ag === 'string') {
        const s = ag.trim()
        if (!s) return []
        try {
          raw = JSON.parse(s)
        } catch {
          return []
        }
      }

      if (Array.isArray(raw)) {
        const rows = raw.filter((x) => x && this.orgAgreementHasDisplayableContent(x))
        if (!rows.length) return []
        return [
          {
            companyName: String(row.lastMerchantName || row.companyName || ''),
            productName: String(row.productName || ''),
            agreements: rows,
          },
        ]
      }

      if (raw && typeof raw === 'object' && raw.thirdAgreement != null) {
        return this.normalizeThirdAgreementToGroups(raw.thirdAgreement)
      }

      return []
    },
    /**
     * 机构协议 thirdAgreement：支持数组（多机构）或单对象 { companyName, productName?, agreements: [] }
     */
    normalizeThirdAgreementToGroups(third) {
      if (third == null) return []
      if (Array.isArray(third)) return third
      if (typeof third !== 'object') return []
      const list = third.agreements
      if (!Array.isArray(list)) return []
      const companyName = third.companyName != null ? String(third.companyName) : ''
      const productName = third.productName != null ? String(third.productName) : ''
      return [
        {
          companyName,
          productName,
          agreements: list,
        },
      ]
    },
    // 行公司名称
    rowCompanyName(row) {
      if (!row) return ''
      if (row.companyName != null && String(row.companyName).trim() !== '') {
        return String(row.companyName).trim()
      }
      return String(row.lastMerchantName || '').trim()
    },
    // 机构协议 iframe 源
    contractIframeSrc(item) {
      if (!item) return ''
      const u = item.contractUrl || ''
      const s = typeof u === 'string' ? u.trim() : ''
      return /^https?:\/\//i.test(s) ? s : ''
    },
    // 机构协议是否可显示内容
    orgAgreementHasDisplayableContent(a) {
      if (!a) return false
      if (this.contractIframeSrc(a)) return true
      const c = a.contractContent
      return typeof c === 'string' && !!c.trim()
    },
    // 机构协议 HTML
    orgAgreementHtml(item) {
      if (!item) return ''
      return this.applyProtocolTemplateReplace(item.contractContent || '')
    },
    // 主协议行上下文
    primaryProtocolRowContext() {
      const rows = (this.pagedata.items || []).filter((row) => this.isPickRowChecked(row))
      const row = rows[0] || (this.pagedata.items || [])[0]
      if (!row) return {}
      return {
        companyName: this.rowCompanyName(row),
        productName: row.productName || '',
        phone: row.phone || '',
      }
    },
    async initMockData() {
      try {
        const res = await API_Common.secondPushProduct(
          this.source || '',
          this.productId || '',
          this.applyId || '',
          0,
          this.isHalfMorePush ? 1 : 0
        )
        if (res && res.data) this.applyCollisionPayload(res.data)
      } catch (e) {
        console.error('secondPushProduct 失败', e)
      }
    },
    formatStatPercent(val) {
      if (val != null && val !== '') {
        const s = String(val)
        return s.includes('%') ? s : `${s}%`
      }
      return '—'
    },
    formatStatCount(val) {
      if (val != null && val !== '') return String(val)
      return '—'
    },
    openOrgProtocolsSheet() {
      if (!this.orgAgreementList.length) return
      this.orgSheetIframesMounted = true
      this.protocolPopupMode = 'org'
      this.protocolTitle = this.titles.org
      this.protocolContent = ''
      this.protocolShow = true
    },
    applyProtocolTemplateReplace(html) {
      const r = this.pagedata || {}
      const ctx = this.primaryProtocolRowContext()
      return replaceTemplateValues(html || '', {
        idCard: r.idCard || '',
        username: r.realName || '',
        phone: r.phone || ctx.phone || '',
        companyName: ctx.companyName || r.merchantName || '',
        productName: ctx.productName || '',
      })
    },
    /** 行上用于与 pagedata.productIds 比对的 id 列表（支持 productIds 或 productId，标量或数组） */
    rowPickIds(row) {
      if (!row) return []
      const raw = row.productIds != null ? row.productIds : row.productId
      if (raw == null || raw === '') return []
      return Array.isArray(raw) ? raw.map((x) => String(x)) : [String(raw)]
    },
    /** pagedata.productIds 与 row.productIds（或 productId）对应则勾选 */
    isPickRowChecked(row) {
      const bag = new Set((this.pagedata.productIds || []).map((x) => String(x)))
      const keys = this.rowPickIds(row)
      if (!keys.length) return false
      return keys.some((k) => bag.has(k))
    },
    onPickRowCheck(row, checked) {
      const keys = this.rowPickIds(row)
      if (!keys.length) return
      const cur = [...(this.pagedata.productIds || [])].map((x) => String(x))
      const set = new Set(cur)
      if (checked) {
        keys.forEach((k) => set.add(k))
      } else {
        keys.forEach((k) => set.delete(k))
      }
      this.$set(this.pagedata, 'productIds', [...set])
    },
    handleApply() {
      if (this.loading) return
      if (!this.productId) {
        this.$toast.fail('产品信息加载失败,请重试')
        return
      }
      this.loading = true
      // H5(0) / 联登(2)：check 取下游链接 → addLoanRecord → appFrame，不走 pushApply
      if (this.isH5Product || this.isUnionLogin) {
        API_Common.handleBatchTrackBase(100099)

        this.submitCheckThenJumpH5()
        return
      }
      API_Common.handleBatchTrackBase(100064)

      if (!this.apiReqType) this.apiReqType = '1'
      this.submitPushApply()
    },
    /** checkMobileStatus 0/2：统一执行一次 check → addLoanRecord → appFrame 跳转 */
    submitCheckThenJumpH5() {
      // 单页面产品属于 showPage=22；复用公共链路可避免跳转前重复调用 check
      this.jumpAppFrameAfterLoanRecord(null, 22)
    },

    handleCloseProtocol() {
      this.protocolPopupMode = ''
      this.protocolTitle = ''
      this.protocolContent = ''
    },
    showProtocolSheetHtml(title, rawHtml) {
      this.protocolPopupMode = ''
      this.protocolTitle = title
      this.protocolContent = this.applyProtocolTemplateReplace(rawHtml)
      this.protocolShow = true
    },
    showProviderServiceTip() {
      this.$toast({
        message:
          '此助贷咨询服务由第三方合作机构提供，第三方信贷专员需要电话转接及门店办理，请您注意接听电话。',
        duration: 3000,
      })
    },
    openProtocolByKey(key) {
      if (key === 'org') {
        this.openOrgProtocolsSheet()
        return
      }
      if (key === 'union') {
        const item = this.findUnionAgreement()
        const raw = item ? this.wrapPlatformBlock(item) : ''
        if (!raw) {
          this.$toast.fail('协议加载中，请稍后再试')
          return
        }
        this.showProtocolSheetHtml(item.contractName || this.titles.union, raw)
        return
      }
      const item = this.findPlatformAgreement(key)
      const raw = item ? this.wrapPlatformBlock(item) : ''
      if (!raw) {
        this.$toast.fail('协议加载中，请稍后再试')
        return
      }
      const title = key === 'share' ? this.titles[13] : key === 'notice' ? this.titles[14] : '协议'
      this.showProtocolSheetHtml(title, raw)
    },
  },
}
</script>

<style lang="scss" scoped>
.result-zk-suc-page {
  padding-bottom: 1.6rem;
  box-sizing: border-box;
  background-color: #edf2f8;
  min-height: 100vh;
}

.result-zk-top-bg {
  width: 100%;
  box-sizing: border-box;
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: 0.72rem;
  min-height: 4.4rem;
  background: linear-gradient(
    180deg,
    #ff5c1a 0%,
    rgba(255, 92, 26, 0.78) 22%,
    rgba(255, 92, 26, 0.42) 48%,
    rgba(255, 92, 26, 0.16) 74%,
    rgba(255, 92, 26, 0) 100%
  );
}

.result-zk-card {
  background: #fff;
  margin: 0 0.32rem 0.24rem;
  padding: 0.36rem 0.32rem;
  border-radius: 0.24rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.result-zk-card--first {
  position: relative;
  z-index: 1;
  margin-top: -3.4rem;
}

.result-zk-card-title,
.salutation-line {
  font-size: 0.28rem;
  color: #666;
  text-align: center;
  line-height: 1.5;
}

.result-zk-amount {
  font-size: 0.72rem;
  font-weight: bold;
  color: #111;
  text-align: center;
  margin-top: 0.2rem;
  letter-spacing: 0.02rem;
}

.result-zk-provider-cap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.28rem;
  font-size: 0.26rem;
  color: #999;
}

.result-zk-provider-cap .cap-line {
  width: 0.64rem;
  height: 0.06rem;
  background: linear-gradient(90deg, transparent, #ddd);
  margin: 0 0.16rem;
}

.result-zk-provider-cap .cap-line.right {
  background: linear-gradient(90deg, #ddd, transparent);
}

.result-zk-provider-cap-center {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
}

.info-ico {
  width: 0.36rem;
  height: 0.36rem;
  border-radius: 50%;
  background: #346ef4;
  color: #fff;
  font-size: 0.22rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-style: normal;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  line-height: 1;
}

.info-ico--cap {
  width: 0.32rem;
  height: 0.32rem;
  font-size: 0.2rem;
}

.result-zk-provider-info {
  padding: 0 0.08rem 0.24rem;
}

.result-zk-provider-info-row {
  margin: 0;
  font-size: 0.28rem;
  color: #333;
  line-height: 1.65;
  text-align: left;
}

.result-zk-stats {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 0.28rem 0.08rem 0.08rem;
  margin-top: 0.08rem;
  border-top: 1px solid #f0f2f5;
}

.result-zk-stat {
  flex: 1;
  text-align: center;
  position: relative;
  padding: 0 0.08rem;
}

.result-zk-stat:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 0.52rem;
  background: linear-gradient(180deg, transparent, #e8eaed 15%, #e8eaed 85%, transparent);
}

.result-zk-stat-val {
  font-size: 0.34rem;
  font-weight: bold;
  color: #ff5713;
  line-height: 1.2;
}

.result-zk-stat-label {
  font-size: 0.22rem;
  color: #8a9199;
  margin-top: 0.12rem;
  line-height: 1.35;
}

.result-zk-recommend {
  margin: 0 0.32rem 0.24rem;
  padding: 0.28rem 0.28rem 0.2rem;
  background: #fff;
  border-radius: 0.24rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.result-zk-recommend-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.2rem;
  padding-bottom: 0.12rem;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
}

.result-zk-recommend-head-text {
  flex: 1;
  min-width: 0;
}

.result-zk-recommend-title {
  font-size: 0.3rem;
  font-weight: 600;
  color: #333;
  line-height: 1.35;
  margin: 0 0 0.1rem;
}

.result-zk-recommend-plans {
  margin: 0;
  padding: 0;
  font-size: 0.24rem;
  font-weight: 400;
  color: #888;
  line-height: 1.55;
}

.result-zk-recommend-plans-prefix {
  margin-right: 0.08rem;
}

.result-zk-recommend-plans-names {
  color: #555;
  font-weight: 500;
}

.result-zk-recommend-arrow {
  flex-shrink: 0;
  margin-top: 0.04rem;
  color: #bbb;
  font-size: 0.32rem;
  transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.result-zk-recommend-arrow--open {
  transform: rotate(180deg);
}

.result-zk-recommend-body {
  overflow: hidden;
}

.result-zk-recommend-expand-enter-active,
.result-zk-recommend-expand-leave-active {
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.28s ease;
}

.result-zk-recommend-expand-enter,
.result-zk-recommend-expand-leave-to {
  max-height: 0 !important;
  opacity: 0;
}

.result-zk-recommend-expand-enter-to,
.result-zk-recommend-expand-leave {
  max-height: 12rem;
  opacity: 1;
}

.result-zk-recommend-list {
  padding-top: 0.2rem;
}

.result-zk-recommend-row {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  border-bottom: 1px solid #f5f5f5;
}

.result-zk-recommend-row:last-child {
  border-bottom: 0;
}

.result-zk-recommend-text {
  flex: 1;
  margin-right: 0.2rem;
  min-width: 0;
}

.result-zk-recommend-check {
  flex-shrink: 0;
}

.result-zk-recommend-product {
  font-size: 0.28rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.08rem;
}

.result-zk-recommend-product::before {
  content: '';
  display: inline-block;
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.12rem;
  background: #ff5713;
  border-radius: 0.02rem;
  vertical-align: middle;
}

.result-zk-recommend-company {
  font-size: 0.24rem;
  color: #666;
  line-height: 1.45;
}

.result-zk-agree-block {
  margin: 0 0.32rem 0.24rem;
  padding: 0.32rem 0.28rem;
  background: #fff;
  border-radius: 0.24rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.result-zk-special {
  font-size: 0.24rem;
  color: #666;
  line-height: 1.65;
  margin: 0 0 0.24rem;
  padding-bottom: 0.24rem;
  border-bottom: 1px solid #f0f0f0;
}

.result-zk-special .link {
  color: #346ef4;
}

.result-zk-tabs {
  display: flex;
  align-items: stretch;
  margin: 0 0 0.24rem;
  padding: 0.1rem;
  background: linear-gradient(180deg, #f3f4f6 0%, #ebecef 100%);
  border-radius: 0.2rem;
  border: 1px solid #e8e9ec;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
}

.result-zk-tab {
  flex: 1;
  text-align: center;
  padding: 0.22rem 0.12rem;
  font-size: 0.28rem;
  color: #888;
  position: relative;
  border-radius: 0.14rem;
  background: transparent;
  transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;
}

.result-zk-tab:not(:first-child) {
  margin-left: 0.08rem;
}

.result-zk-tab.active {
  color: #ff5713;
  font-weight: 600;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07), 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}

.result-zk-protocol-box {
  max-height: min(68vh, 13rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.28rem 0.24rem;
  background: #f8f9fa;
  border: 1px solid #f0f0f0;
  border-radius: 0.16rem;
  font-size: 0.26rem;
  color: #666;
  line-height: 1.55;
  -webkit-overflow-scrolling: touch;
}

.result-zk-protocol-box ::v-deep .protocol-inner-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 0.16rem;
  text-align: center;
}

.result-zk-protocol-box iframe {
  display: block;
  width: 100%;
  height: 52vh;
  min-height: 5.6rem;
  border: 0;
  border-radius: 0.08rem;
  background: #fff;
}

.result-zk-protocol-box .protocol-org-html {
  font-size: 0.26rem;
  color: #555;
  line-height: 1.6;
}

.result-zk-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.24rem 0.32rem calc(0.24rem + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  z-index: 99;
}

.result-zk-apply-btn.van-button {
  width: 100%;
  height: 0.96rem;
  font-size: 0.32rem;
  font-weight: 600;
  border: 0;
  color: #fff;
  background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
  box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
}

.result-zk-suc-page.tg-frame {
  background-color: #f3f4f6;

  .result-zk-top-bg {
    background: linear-gradient(
      180deg,
      #1fbf75 0%,
      rgba(31, 191, 117, 0.78) 22%,
      rgba(31, 191, 117, 0.42) 48%,
      rgba(31, 191, 117, 0.16) 74%,
      rgba(31, 191, 117, 0) 100%
    );
  }

  .result-zk-card,
  .result-zk-recommend,
  .result-zk-agree-block {
    box-shadow: 0 2px 10px rgba(31, 191, 117, 0.08);
  }

  .result-zk-card-title,
  .salutation-line {
    color: #888;
  }

  .result-zk-amount {
    color: #1a2744;
  }

  .result-zk-provider-info-row {
    color: #1a2744;
  }

  .result-zk-stat-val {
    color: #1fbf75;
  }

  .result-zk-stat-label {
    color: #888;
  }

  .result-zk-recommend-product::before {
    background: #1fbf75;
  }

  .result-zk-special {
    color: #666;
  }

  .result-zk-tab.active {
    color: #1fbf75;
  }

  .result-zk-protocol-box {
    background: #f5fbf7;
    border-color: #e0f3e8;
  }

  .result-zk-apply-btn.van-button {
    background: linear-gradient(90deg, #ff8a45 0%, #ff5c1a 100%);
    box-shadow: 0 0.12rem 0.28rem rgba(255, 92, 26, 0.28);
  }
}
</style>

<style lang="scss">
/* 协议半屏：挂到 body 的弹层需非 scoped */
.van-popup.protocol-sheet-zk.van-action-sheet {
  max-height: 88vh;
}

.protocol-sheet-zk .van-action-sheet__content {
  padding: 0;
  max-height: inherit;
  background: #fff;
}

.protocol-sheet-body {
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
}

.protocol-sheet-header {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0.96rem;
  padding: 0.2rem 0.88rem;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
  border-bottom: 1px solid #eef0f3;
}

.protocol-sheet-header-title {
  max-width: 100%;
  padding: 0 0.08rem;
  font-size: 0.32rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.35;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.protocol-sheet-header-close {
  position: absolute;
  right: 0.24rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.4rem;
  color: #b0b6bf;
  padding: 0.12rem;
  line-height: 1;
  cursor: pointer;
}

.protocol-sheet-scroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0.28rem calc(0.28rem + env(safe-area-inset-bottom, 0px));
}

.protocol-sheet-org {
  width: 100%;
  box-sizing: border-box;
}

.protocol-sheet-org-frame iframe {
  display: block;
  width: 100%;
  height: min(70vh, 12rem);
  min-height: 5.6rem;
  border: 0;
  border-radius: 0.12rem;
  background: #f5f6f8;
}

.protocol-sheet-org-frame .protocol-org-html {
  font-size: 0.26rem;
  color: #555;
  line-height: 1.6;
  padding: 0.12rem 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.protocol-sheet-org-frame .protocol-inner-title {
  font-size: 0.28rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0 0 0.16rem;
}

.protocol-sheet-org-frame + .protocol-sheet-org-frame {
  margin-top: 0.2rem;
}

.protocol-sheet-html {
  font-size: 0.26rem;
  color: #555;
  line-height: 1.6;
  padding-top: 0.12rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

.protocol-sheet-html .protocol-inner-title {
  font-size: 0.28rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0.16rem 0 0.2rem;
}
</style>
